export default {
    sideBarWidth: '240px'
}